import { EntryMethod } from '../EntryMethod';

export const getNumberOfTreesPlanted = (
  entryMethod: EntryMethod,
  tuesdayDrawEnabled: boolean,
  fridayDrawEnabled: boolean,
) => {
  let numberOfTreesPlantedPerWeek;
  if (entryMethod === EntryMethod.FreeSubscription) {
    numberOfTreesPlantedPerWeek = 0;
  } else if (tuesdayDrawEnabled && fridayDrawEnabled) {
    numberOfTreesPlantedPerWeek = 2;
  } else {
    numberOfTreesPlantedPerWeek = 1;
  }
  return numberOfTreesPlantedPerWeek;
};
